module.exports = __webpack_public_path__ + "static/media/mail.2a5f3a42.svg";